import type { R, RP } from '@/api';
import type { TenantAppConfig } from './model';
import request from '@/utils/request';
import LzdUtil, { requestResult } from '@/utils/lzd-util';
import LzdAjax from '@/utils/lzd-ajax';

/** 授权 */
async function authApps(data: RP) {
  if (!data?.tenantId) {
    return LzdUtil.tipsError('data.tenantId must not be blank');
  }
  if (!data?.others) {
    return LzdUtil.tipsError('data.others must not be empty');
  }
  return LzdAjax.post<unknown>(
    '/bsl/tenant/app/config/auth/apps',
    data,
    true,
    true
  );
}

/** 查询租户应用列表 */
export async function queryAppConfigs() {
  const res = await request.post<R<TenantAppConfig[]>>(
    '/bsl/tenant/app/config/query/list'
  );
  return requestResult(res);
}

/** 查询租户应用列表 */
export async function queryList() {
  return LzdAjax.post<TenantAppConfig[]>(
    '/bsl/tenant/app/config/query/list',
    { where: [] },
    true,
    false
  ).then((v) => {
    if (!v.data || v.data.length === 0) {
      return [{ appId: 'GP', appName: '毕业设计管理' }];
    }
    return v.data;
  });
}

/** APP 配置管理 */
class tenantAppConfigApi {
  static queryList = queryList;
  static authApps = authApps;
}

export default tenantAppConfigApi;
